import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Schoolpicnicorganiser() {



    const cardData =
    {
        keyword: 'School Picnic Organisers in Pune',
        heading: 'Anand Krushi Paryatan Kendra: School Picnic Organisers in Pune',
        headingDescription: 'Looking for trusted and experienced school picnic organisers in Pune? Anand Krushi Paryatan Kendra is one of the top choices for organizing educational, fun-filled, and safe school picnics just 55 km from Pune. Spread over 40 acres in Morachi Chincholi, this agri-tourism destination offers a complete one-day package tailored for students of all age groups. As professional school picnic organisers in Pune, the team at Anand Krushi Paryatan Kendra handles everything from activity planning and meal arrangements to safety and supervision. Students enjoy exciting rural experiences such as bullock cart and tractor rides, horse riding, boating, swimming, and rain dance sessions. Cultural activities like puppet shows, magic shows, and traditional village games add to the learning and entertainment.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Mhalasakant Agritourism",
    "description": "Perfect for school picnics, Mhalasakant offers full-day packages that include breakfast, lunch, high tea, and over 15 activities such as bullock-cart rides, zip-lining, archery, magic shows, adventure games, puppet shows, and rain dance. Their child-friendly environment and trained staff ensure safety and supervision throughout the visit. Advance booking with 25% deposit is required for group visits."
  },
  {
    "title": "Mauli Krushi Paryatan Kendra",
    "description": "This location offers a perfect mix of learning and fun with educational farming tours, animal interaction zones, rural games, nature trails, and traditional Maharashtrian meals. Ideal for primary and secondary students, their packages are specially curated for schools and include both meals and structured activities. Affordable pricing and hygienic meal setups make it a preferred choice for schools."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "Anand Krushi offers school picnic packages that include rain dance, tractor rides, bullock-cart rides, puppet shows, splash pool access, peacock spotting, and traditional games. They provide meals (breakfast, lunch, evening tea) and shaded seating arrangements for school groups. Special discounts are available for groups with over 30 students. Teachers are also provided complimentary entry and meals."
  },
  {
    "title": "Jay Malhar Krushi Paryatan",
    "description": "Jay Malhar’s picnic package includes access to 45+ activities such as zip line, archery, rope games, trampoline, swimming pool, rain dance with DJ, and seasonal hurda parties. With dedicated guides and coordinators for student groups, the entire day is supervised for safety and enjoyment. School groups benefit from discount pricing and custom itineraries."
  },
  {
    "title": "Mayur Agro Tourism",
    "description": "Ideal for nature-based school outings, Mayur Agro offers educational experiences in farming, cow milking, organic composting, and local food preparation. Students can also enjoy simple rope games, storytelling corners, and art activities like diya painting and pottery. Their programs are designed to be interactive and suitable for all age groups."
  }
],




  "services": [
    {
      "name": "Top School Picnic Planners in Pune",
      "description": "Organizers like Nisargshala, Raikar Farms, Go Crazy Adventure, Sneh Resort, Pawar Agro Resort, and Avani Agro Tourism specialize in safe, educational, and fun school outings near Pune."
    },
    {
      "name": "Educational Trip Organisers",
      "description": "These planners offer curated agro-education, nature walks, renewable energy demos, animal husbandry, and cultural learning tailored to school curricula."
    },
    {
      "name": "Budget-Friendly School Outings",
      "description": "Packages range from affordable ₹350/student (e.g., KonkanKanya, Picnic Point) up to ₹1,600—offering meals, activities, and safety supervision."
    },
    {
      "name": "School Day Tour Arrangements",
      "description": "Full-day itineraries include breakfast, guided farm/nature tours, adventure activities, maps, teacher support, and transport coordination."
    },
    {
      "name": "Safety-Focused Organisers",
      "description": "Prioritizing supervision, trained guides, first-aid, safe play zones, river safety, and dedicated staff-to-child ratios."
    },
    {
      "name": "Farm Picnic Planning for Schools",
      "description": "Curated farm visits with interactive workshops on organic farming, composting, vegetable growing, and animal care."
    },
    {
      "name": "One-Day Picnic with Food and Transport",
      "description": "All-inclusive packages include meals, hi-tea, bus arrangements, and activity coordination under one booking."
    },
    {
      "name": "Nature and Adventure Trip Planning",
      "description": "Combining adventure (zipline, climbing, rope courses) with nature learning, such as bird-watching and line walks."
    },
    {
      "name": "Customized Itinerary for Schools",
      "description": "Tailored itineraries based on age groups, curricular goals, and group size, with optional camping or eco-trips."
    },
    {
      "name": "Permission and Documentation Handled",
      "description": "Planners manage school permissions, consent forms, ID requirements, and safety disclaimers for hassle-free outings."
    },
    {
      "name": "Fun Learning Outdoor Tours",
      "description": "Interactive trips featuring science-based learning, cultural immersion, craft workshops, and eco-awareness activities."
    },
    {
      "name": "Group Activity Organisers for Students",
      "description": "Hostage of structured team-building games, treasure hunts, river rafting, and obstacle challenges in supervised groups."
    },
    {
      "name": "School Trip with Guides and Facilitators",
      "description": "On-site naturalists, agrarian guides, and volunteers accompany each group for educational and safety guidance."
    },
    {
      "name": "Picnic Games and Team Activities",
      "description": "Includes events like sack races, tug-of-war, cricket, archery, rain dance, and cultural performances."
    },
    {
      "name": "School Trip Vendors in Pune",
      "description": "Local vendors including Ninargshala, Raikar Farms, Go Crazy, Sneh, Pawar, Avani, KonkanKanya, and Picnic Point provide comprehensive school trip services."
    }
  ],
  "tableData": [
    ["Top School Picnic Planners in Pune", "Educational Trip Organisers"],
    ["Budget-Friendly School Outings", "School Day Tour Arrangements"],
    ["Safety-Focused Organisers", "Farm Picnic Planning for Schools"],
    ["One-Day Picnic with Food and Transport", "Nature and Adventure Trip Planning"],
    ["Customized Itinerary for Schools", "Permission and Documentation Handled"],
    ["Fun Learning Outdoor Tours", "Group Activity Organisers for Students"],
    ["School Trip with Guides and Facilitators", "Picnic Games and Team Activities"],
    ["School Trip Vendors in Pune", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Specialized School Picnic Packages",
    "WhyChoosedescription": "Several organizers near Pune offer tailored picnic packages designed specifically for schools. These packages include educational tours, interactive farm activities, and fun games that keep students engaged and entertained throughout the day."
  },
  {
    "WhyChooseheading": "Safe and Supervised Outings",
    "WhyChoosedescription": "Organizers ensure student safety with supervised activities, secure transport options, and well-planned schedules. Experienced staff guide students during visits to agro-tourism centers like Morachi Chincholi, providing a safe and enjoyable environment."
  },
  {
    "WhyChooseheading": "Diverse Activities and Learning",
    "WhyChoosedescription": "School picnics typically include bullock cart rides, tractor tours, nature trails, bird watching, and traditional rural games. These activities offer hands-on learning about agriculture, environment, and rural culture."
  },
  {
    "WhyChooseheading": "Affordable Group Pricing",
    "WhyChoosedescription": "Group rates and customizable packages help schools stay within budget while providing a rich, memorable experience. Meals, activities, and transport are often bundled together for convenience and cost savings."
  },
  {
    "WhyChooseheading": "Convenient Transportation Options",
    "WhyChoosedescription": "Many organizers provide or coordinate reliable bus and tempo-traveller services from Pune to Morachi Chincholi, ensuring hassle-free travel for large groups of students."
  },
  {
    "WhyChooseheading": "Flexible Booking and Support",
    "WhyChoosedescription": "School picnic organizers offer flexible booking options and comprehensive support, including assistance with itinerary planning, meal arrangements, and special event coordination."
  }
]

































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Who are the top school picnic organizers in Pune?',
    answer: 'Leading organizers include agro‑tourism centers near Pune such as Anand Krushi, Mhalasakant Agro Tourism, and farm‑stay resorts offering curated school picnic packages.',
  },
  {
    id: 'FAQ2',
    question: 'What services do school picnic organizers offer?',
    answer: 'They provide end‑to‑end services including transport coordination, activity planning (farm tours, nature walks, games), meals, supervision, and first‑aid support.',
  },
  {
    id: 'FAQ3',
    question: 'Can they handle large school groups?',
    answer: 'Yes, most organizers are experienced in managing groups of 50–200 students with dedicated staff, group discounts, and safety protocols in place.',
  },
  {
    id: 'FAQ4',
    question: 'What kind of activities are included?',
    answer: 'Typical activities include peacock watching, tractor rides, traditional games, interactive farming sessions, rain dance, and eco‑education workshops.',
  },
  {
    id: 'FAQ5',
    question: 'Do they provide meals and snacks?',
    answer: 'Yes, wholesome, farm‑to‑table vegetarian meals and refreshments are part of the picnic package, with provisions for dietary preferences.',
  },
  {
    id: 'FAQ6',
    question: 'Are safety and supervision ensured?',
    answer: 'Absolutely. Organizers provide trained staff, safety briefs, boundary control, and first‑aid facilities to ensure student safety throughout the event.',
  },
  {
    id: 'FAQ7',
    question: 'Do they arrange transportation?',
    answer: 'Yes, most school picnic organizers assist in arranging buses or vans from Pune, coordinating pick‑up and drop‑off logistics.',
  },
  {
    id: 'FAQ8',
    question: 'What is the cost per student?',
    answer: 'Prices typically range from ₹400–800 per student depending on activities, meals, and transport, with special rates for large groups.',
  },
  {
    id: 'FAQ9',
    question: 'How far in advance should schools book?',
    answer: 'Schools are advised to book at least 2–4 weeks in advance, especially for popular dates during peak seasons.',
  },
  {
    id: 'FAQ10',
    question: 'How do I contact school picnic organizers in Pune?',
    answer: 'You can reach them via their official websites, WhatsApp or phone numbers; many also support online booking or email inquiries.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Kavita Deshpande, Teacher, Pune',
    feedback: "The picnic organized by Anand Krushi was fantastic—well‑structured, safe, and the kids were completely engaged throughout the day.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Sandeep Malhotra, Principal, Pimpri',
    feedback: "We appreciated the professionalism of the organizers. Transport, activities, and meals were all seamless. Highly recommend them for school outings.",
    rating: 5,
  },
];



































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const picnicSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "School Picnic Organisers in Pune - Anand Krushi Paryatan Kendra",
  "description": "We are trusted school picnic organisers in Pune offering educational day trips, nature and farm-based outings, adventure activities, food, transport, and full safety arrangements for students.",
  "url": "https://morachichincholi.in/school-picnic-organisers",
  "sameAs": "https://morachichincholi.in/",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "telephone": "+91-12345-67890",
    "email": "info@morachichincholi.in"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, India"
  },
  "serviceType": [
    "School picnic planning",
    "Educational tours for schools",
    "One-day student trips",
    "Nature and farm visits",
    "Student safety and permissions"
  ]
};



    return (
        <div>

<Helmet>
  <title>School Picnic Organisers in Pune | Educational Farm Trips & One-Day Outings</title>
  <meta 
    name="description" 
    content="Top school picnic organisers in Pune offering safe, educational, and fun one-day outings. Includes transport, food, guided activities, and custom farm-based itineraries." 
  />
  <meta 
    name="keywords" 
    content="Top school picnic planners in Pune, Educational trip organisers, Budget-friendly school outings, School day tour arrangements, Safety-focused organisers, Farm picnic planning for schools, One-day picnic with food and transport, Nature and adventure trip planning, Customized itinerary for schools, Permission and documentation handled, Fun learning outdoor tours, Group activity organisers for students, School trip with guides and facilitators, Picnic games and team activities, School trip vendors in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(picnicSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Schoolpicnicorganiser;